// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"cd6d39b3","92":"25b926d7","99":"f80448ba","215":"10ecda4c","337":"e236bf35","443":"32b8536e","479":"e69e6539","531":"d2b67928","952":"6e6ab7fc"}[chunkId] + ".chunk.js";
};